import styled from "styled-components";

export const EditTournamentPrizeWrapper = styled.div`
  display: flex;
  position: relative;
  gap: 20px;

  .overlay {
    font-family: Pretendard;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgb(255, 255, 255);
    padding: 5px;
    position: absolute;
    top: 0-3px;
    left: -5px;
    width: 100%;
    height: calc(100% - 4px);
    border-radius: 6.744px;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 1;
  }
`;

export const EditTournamentPrizeBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .title {
    display: flex;
    gap: 30px;
    position: relative;
    align-items: center;

    > .name {
      font-family: Pretendard;
      font-weight: 600;
      font-size: 20px;
      width: 169px;
      color: #121212;
    }
  }
`;

export const EditTournamentPrizeSettingItem = styled.div<{
  $isAdd?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  border-radius: 14px;
  background: ${(p) => (p.$isAdd ? "#fff" : "#f8f8f8")};
  padding: ${(p) => (p.$isAdd ? "0" : "15px")};

  > .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.6;
    z-index: 100;
    border-radius: 14px;
    color: #c6c6c6;
    font-family: Pretendard;
    font-size: 48px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 57.6px */
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const EditTournamentPrizeInput = styled.div`
  position: relative;

  > input {
    width: 150px;
    height: 28px;
    border-radius: 2.7px;
    box-sizing: border-box;
    padding: 5px 8px;
    border: 0.67px solid var(--Black-200, #b7b7b7);
    outline: none;
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;

    &.daily {
      width: 48px;
    }
  }

  > span {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 10.79px;
    position: absolute;
    top: 8px;
    right: 5px;
  }
`;

export const EditTournamentPrizeSettingWrapper = styled.div`
  margin-left: 194px;
  margin-top: 7px;
  background: #f0f0f0;
  padding: 15px;
  border-radius: 8px;
  width: max-content;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  max-height: 289px;
  overflow: auto;
  scrollbar-width: none;
`;

export const EditTournamentPrizeInfoWrapper = styled.div`
  margin-top: 110px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .wrapper {
    display: flex;
    gap: 18px;

    > .can {
      font-family: Pretendard;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      gap: 10px;

      > span {
        font-weight: 600;
      }
    }
  }
`;

export const EditTournamentPrizeInfoSettingHeader = styled.div`
  display: flex;
  flex-direction: column;
  height: 28px;
  align-items: center;
  gap: 10px;
  font-family: Pretendard;
  font-weight: 600;
  font-size: 17px;
`;

export const EditTournamentPrizeInfoSettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
`;

export const EditTournamentPrizeDiscount = styled.div`
  display: flex;
  padding: 15px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 14px;
  background: #f8f8f8;

  > .line {
    width: 100%;
    height: 1px;
    background: #e5e5e5;
  }

  > .item {
    display: flex;
    justify-content: space-between;
    width: 100%;

    > .name {
      color: #808080;
      font-family: Pretendard;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; /* 16.8px */
    }

    > .value {
      color: #ff0000;
      font-family: Pretendard;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%; /* 19.2px */
    }

    &:first-child {
      > .value {
        color: #121212;
      }
    }

    &:last-child {
      > .name {
        color: #121212;
        font-weight: 600;
      }
      > .value {
        color: #7f25fb;
      }
    }
  }
`;

export const EditTournamentType = styled.div`
  padding: 8px 15px;
  border-radius: 14px;
  background: #f0eaff;
  color: #7f25fb;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;

export const EditTournamentPrizeTotal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > .name {
    font-family: Pretendard;
    font-weight: 500;
    font-size: 14px;
  }

  > .value {
    display: flex;
    padding: 15px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    align-self: stretch;
    border-radius: 14px;
    background: #f8f8f8;
    color: #121212;
    font-family: Pretendard;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 28.8px */

    > .text {
      color: #808080;
      font-size: 14px;
      font-weight: 500;
      line-height: 120%; /* 16.8px */
    }
  }
`;
